import React from 'react';
import { fmtMoney } from './format';

// `key` doubles as the metric name handed to onTileClick — the same strings
// utils/rollup.js's tileDrilldown() switches on, so no page needs a lookup
// table to turn a click into the detail behind it.
const TILES = [
  { key: 'time', label: 'TIME', field: 'totalTime', color: '#3b82f6' },
  { key: 'invoiced', label: 'INVOICED', field: 'totalInvoiced', color: '#10b981' },
  { key: 'writeoffs', label: 'WRITE-OFFS', field: 'totalWriteOffs', color: '#ef4444' },
  { key: 'wip', label: 'WIP', field: 'wip', color: '#f59e0b' },
  { key: 'ar', label: 'A/R', field: 'arBalance', color: '#8b5cf6' },
];

// `captions` (optional, { [tileKey]: text }) adds a small line under a tile's
// figure -- e.g. that A/R stays an as-of-today balance while the page is
// filtered to a date range.
export default function MetricTiles({ metrics, onTileClick, captions }) {
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: 16, marginBottom: 24,
    }}>
      {TILES.map(({ key, label, field, color }) => {
        const Tag = onTileClick ? 'button' : 'div';
        return (
          <Tag
            key={key}
            type={onTileClick ? 'button' : undefined}
            onClick={onTileClick ? () => onTileClick(key) : undefined}
            style={{
              background: 'white', borderRadius: 12, padding: 20,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              cursor: onTileClick ? 'pointer' : 'default',
              // A <button> brings its own chrome and centring; strip both so a
              // clickable tile is pixel-identical to an inert one.
              border: 'none', font: 'inherit', textAlign: 'left', display: 'block', width: '100%',
            }}
          >
            {/* <span>s, not <div>s: a button may only contain phrasing content. */}
            <span style={{
              display: 'block', fontSize: 11, fontWeight: 700, color: '#6b7280',
              letterSpacing: '0.05em', marginBottom: 8,
            }}>
              {label}
            </span>
            <span style={{ display: 'block', fontSize: 28, fontWeight: 700, color }}>
              {fmtMoney(metrics?.[field])}
            </span>
            {captions?.[key] && (
              <span style={{ display: 'block', fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                {captions[key]}
              </span>
            )}
          </Tag>
        );
      })}
    </div>
  );
}
